"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeMixin = void 0;
var _styledComponents = require("styled-components");
var _helpers = require("../helpers");
var activeMixin = function activeMixin(props) {
  return (0, _styledComponents.css)(["", ""], props.active && (0, _styledComponents.css)(["background-color:", ";color:", ";border:1px solid ", ";&:hover,&:focus{color:", ";background-color:", ";border:1px solid ", ";}"], (0, _helpers.hex2Rgba)((0, _helpers.getColor)(props, "activeColor", "primary"), 0.2), function (props) {
    return (0, _helpers.getColor)(props, "activeColor", "primary");
  }, function (props) {
    return (0, _helpers.hex2Rgba)((0, _helpers.getColor)(props, "activeColor", "primary"), 0.2);
  }, function (props) {
    return (0, _helpers.getColor)(props, "activeColor", "primary");
  }, (0, _helpers.hex2Rgba)((0, _helpers.getColor)(props, "activeColor", "primary"), 0.3), function (props) {
    return (0, _helpers.hex2Rgba)((0, _helpers.getColor)(props, "activeColor", "primary"), 0.3);
  }));
};
exports.activeMixin = activeMixin;